/* eslint-disable */
import { PluginContainerData, Media } from './common';
import { PollData_Poll_Settings_Permissions_ViewRole, PollData_Poll_Settings_Permissions_VoteRole, PollData_Layout_PollLayout_Type, PollData_Layout_PollLayout_Direction, PollData_Design_PollDesign_Background_Type, } from './plugin_poll.enums';
export function pollData_Poll_Settings_Permissions_ViewRoleFromJSON(object) {
    switch (object) {
        case 0:
        case 'CREATOR':
            return PollData_Poll_Settings_Permissions_ViewRole.CREATOR;
        case 1:
        case 'VOTERS':
            return PollData_Poll_Settings_Permissions_ViewRole.VOTERS;
        case 2:
        case 'EVERYONE':
            return PollData_Poll_Settings_Permissions_ViewRole.EVERYONE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PollData_Poll_Settings_Permissions_ViewRole.UNRECOGNIZED;
    }
}
export function pollData_Poll_Settings_Permissions_ViewRoleToJSON(object) {
    switch (object) {
        case PollData_Poll_Settings_Permissions_ViewRole.CREATOR:
            return 'CREATOR';
        case PollData_Poll_Settings_Permissions_ViewRole.VOTERS:
            return 'VOTERS';
        case PollData_Poll_Settings_Permissions_ViewRole.EVERYONE:
            return 'EVERYONE';
        default:
            return 'UNKNOWN';
    }
}
export function pollData_Poll_Settings_Permissions_VoteRoleFromJSON(object) {
    switch (object) {
        case 0:
        case 'SITE_MEMBERS':
            return PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS;
        case 1:
        case 'ALL':
            return PollData_Poll_Settings_Permissions_VoteRole.ALL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PollData_Poll_Settings_Permissions_VoteRole.UNRECOGNIZED;
    }
}
export function pollData_Poll_Settings_Permissions_VoteRoleToJSON(object) {
    switch (object) {
        case PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS:
            return 'SITE_MEMBERS';
        case PollData_Poll_Settings_Permissions_VoteRole.ALL:
            return 'ALL';
        default:
            return 'UNKNOWN';
    }
}
export function pollData_Layout_PollLayout_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'LIST':
            return PollData_Layout_PollLayout_Type.LIST;
        case 1:
        case 'GRID':
            return PollData_Layout_PollLayout_Type.GRID;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PollData_Layout_PollLayout_Type.UNRECOGNIZED;
    }
}
export function pollData_Layout_PollLayout_TypeToJSON(object) {
    switch (object) {
        case PollData_Layout_PollLayout_Type.LIST:
            return 'LIST';
        case PollData_Layout_PollLayout_Type.GRID:
            return 'GRID';
        default:
            return 'UNKNOWN';
    }
}
export function pollData_Layout_PollLayout_DirectionFromJSON(object) {
    switch (object) {
        case 0:
        case 'LTR':
            return PollData_Layout_PollLayout_Direction.LTR;
        case 1:
        case 'RTL':
            return PollData_Layout_PollLayout_Direction.RTL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PollData_Layout_PollLayout_Direction.UNRECOGNIZED;
    }
}
export function pollData_Layout_PollLayout_DirectionToJSON(object) {
    switch (object) {
        case PollData_Layout_PollLayout_Direction.LTR:
            return 'LTR';
        case PollData_Layout_PollLayout_Direction.RTL:
            return 'RTL';
        default:
            return 'UNKNOWN';
    }
}
export function pollData_Design_PollDesign_Background_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'COLOR':
            return PollData_Design_PollDesign_Background_Type.COLOR;
        case 1:
        case 'IMAGE':
            return PollData_Design_PollDesign_Background_Type.IMAGE;
        case 2:
        case 'GRADIENT':
            return PollData_Design_PollDesign_Background_Type.GRADIENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PollData_Design_PollDesign_Background_Type.UNRECOGNIZED;
    }
}
export function pollData_Design_PollDesign_Background_TypeToJSON(object) {
    switch (object) {
        case PollData_Design_PollDesign_Background_Type.COLOR:
            return 'COLOR';
        case PollData_Design_PollDesign_Background_Type.IMAGE:
            return 'IMAGE';
        case PollData_Design_PollDesign_Background_Type.GRADIENT:
            return 'GRADIENT';
        default:
            return 'UNKNOWN';
    }
}
const basePollData = {};
export const PollData = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData);
        message.containerData =
            object.containerData !== undefined && object.containerData !== null
                ? PluginContainerData.fromJSON(object.containerData)
                : undefined;
        message.poll =
            object.poll !== undefined && object.poll !== null
                ? PollData_Poll.fromJSON(object.poll)
                : undefined;
        message.layout =
            object.layout !== undefined && object.layout !== null
                ? PollData_Layout.fromJSON(object.layout)
                : undefined;
        message.design =
            object.design !== undefined && object.design !== null
                ? PollData_Design.fromJSON(object.design)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.poll !== undefined &&
            (obj.poll = message.poll ? PollData_Poll.toJSON(message.poll) : undefined);
        message.layout !== undefined &&
            (obj.layout = message.layout ? PollData_Layout.toJSON(message.layout) : undefined);
        message.design !== undefined &&
            (obj.design = message.design ? PollData_Design.toJSON(message.design) : undefined);
        return obj;
    },
};
const basePollData_Poll = {};
export const PollData_Poll = {
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, basePollData_Poll);
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : undefined;
        message.title =
            object.title !== undefined && object.title !== null ? String(object.title) : undefined;
        message.creatorId =
            object.creatorId !== undefined && object.creatorId !== null
                ? String(object.creatorId)
                : undefined;
        message.image =
            object.image !== undefined && object.image !== null
                ? Media.fromJSON(object.image)
                : undefined;
        message.options = ((_a = object.options) !== null && _a !== void 0 ? _a : []).map((e) => PollData_Poll_Option.fromJSON(e));
        message.settings =
            object.settings !== undefined && object.settings !== null
                ? PollData_Poll_Settings.fromJSON(object.settings)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.title !== undefined && (obj.title = message.title);
        message.creatorId !== undefined && (obj.creatorId = message.creatorId);
        message.image !== undefined &&
            (obj.image = message.image ? Media.toJSON(message.image) : undefined);
        if (message.options) {
            obj.options = message.options.map(e => (e ? PollData_Poll_Option.toJSON(e) : undefined));
        }
        else {
            obj.options = [];
        }
        message.settings !== undefined &&
            (obj.settings = message.settings
                ? PollData_Poll_Settings.toJSON(message.settings)
                : undefined);
        return obj;
    },
};
const basePollData_Poll_Option = {};
export const PollData_Poll_Option = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Poll_Option);
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : undefined;
        message.title =
            object.title !== undefined && object.title !== null ? String(object.title) : undefined;
        message.image =
            object.image !== undefined && object.image !== null
                ? Media.fromJSON(object.image)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.title !== undefined && (obj.title = message.title);
        message.image !== undefined &&
            (obj.image = message.image ? Media.toJSON(message.image) : undefined);
        return obj;
    },
};
const basePollData_Poll_Settings = {};
export const PollData_Poll_Settings = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Poll_Settings);
        message.permissions =
            object.permissions !== undefined && object.permissions !== null
                ? PollData_Poll_Settings_Permissions.fromJSON(object.permissions)
                : undefined;
        message.showVoters =
            object.showVoters !== undefined && object.showVoters !== null
                ? Boolean(object.showVoters)
                : undefined;
        message.showVotesCount =
            object.showVotesCount !== undefined && object.showVotesCount !== null
                ? Boolean(object.showVotesCount)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.permissions !== undefined &&
            (obj.permissions = message.permissions
                ? PollData_Poll_Settings_Permissions.toJSON(message.permissions)
                : undefined);
        message.showVoters !== undefined && (obj.showVoters = message.showVoters);
        message.showVotesCount !== undefined && (obj.showVotesCount = message.showVotesCount);
        return obj;
    },
};
const basePollData_Poll_Settings_Permissions = {
    view: PollData_Poll_Settings_Permissions_ViewRole.CREATOR,
    vote: PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS,
};
export const PollData_Poll_Settings_Permissions = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Poll_Settings_Permissions);
        message.view =
            object.view !== undefined && object.view !== null
                ? pollData_Poll_Settings_Permissions_ViewRoleFromJSON(object.view)
                : PollData_Poll_Settings_Permissions_ViewRole.CREATOR;
        message.vote =
            object.vote !== undefined && object.vote !== null
                ? pollData_Poll_Settings_Permissions_VoteRoleFromJSON(object.vote)
                : PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS;
        message.allowMultipleVotes =
            object.allowMultipleVotes !== undefined && object.allowMultipleVotes !== null
                ? Boolean(object.allowMultipleVotes)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.view !== undefined &&
            (obj.view = pollData_Poll_Settings_Permissions_ViewRoleToJSON(message.view));
        message.vote !== undefined &&
            (obj.vote = pollData_Poll_Settings_Permissions_VoteRoleToJSON(message.vote));
        message.allowMultipleVotes !== undefined &&
            (obj.allowMultipleVotes = message.allowMultipleVotes);
        return obj;
    },
};
const basePollData_Layout = {};
export const PollData_Layout = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Layout);
        message.poll =
            object.poll !== undefined && object.poll !== null
                ? PollData_Layout_PollLayout.fromJSON(object.poll)
                : undefined;
        message.options =
            object.options !== undefined && object.options !== null
                ? PollData_Layout_OptionLayout.fromJSON(object.options)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poll !== undefined &&
            (obj.poll = message.poll ? PollData_Layout_PollLayout.toJSON(message.poll) : undefined);
        message.options !== undefined &&
            (obj.options = message.options
                ? PollData_Layout_OptionLayout.toJSON(message.options)
                : undefined);
        return obj;
    },
};
const basePollData_Layout_PollLayout = {
    type: PollData_Layout_PollLayout_Type.LIST,
    direction: PollData_Layout_PollLayout_Direction.LTR,
};
export const PollData_Layout_PollLayout = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Layout_PollLayout);
        message.type =
            object.type !== undefined && object.type !== null
                ? pollData_Layout_PollLayout_TypeFromJSON(object.type)
                : PollData_Layout_PollLayout_Type.LIST;
        message.direction =
            object.direction !== undefined && object.direction !== null
                ? pollData_Layout_PollLayout_DirectionFromJSON(object.direction)
                : PollData_Layout_PollLayout_Direction.LTR;
        message.enableImage =
            object.enableImage !== undefined && object.enableImage !== null
                ? Boolean(object.enableImage)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = pollData_Layout_PollLayout_TypeToJSON(message.type));
        message.direction !== undefined &&
            (obj.direction = pollData_Layout_PollLayout_DirectionToJSON(message.direction));
        message.enableImage !== undefined && (obj.enableImage = message.enableImage);
        return obj;
    },
};
const basePollData_Layout_OptionLayout = {};
export const PollData_Layout_OptionLayout = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Layout_OptionLayout);
        message.enableImage =
            object.enableImage !== undefined && object.enableImage !== null
                ? Boolean(object.enableImage)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.enableImage !== undefined && (obj.enableImage = message.enableImage);
        return obj;
    },
};
const basePollData_Design = {};
export const PollData_Design = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Design);
        message.poll =
            object.poll !== undefined && object.poll !== null
                ? PollData_Design_PollDesign.fromJSON(object.poll)
                : undefined;
        message.options =
            object.options !== undefined && object.options !== null
                ? PollData_Design_OptionDesign.fromJSON(object.options)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poll !== undefined &&
            (obj.poll = message.poll ? PollData_Design_PollDesign.toJSON(message.poll) : undefined);
        message.options !== undefined &&
            (obj.options = message.options
                ? PollData_Design_OptionDesign.toJSON(message.options)
                : undefined);
        return obj;
    },
};
const basePollData_Design_PollDesign = {};
export const PollData_Design_PollDesign = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Design_PollDesign);
        message.background =
            object.background !== undefined && object.background !== null
                ? PollData_Design_PollDesign_Background.fromJSON(object.background)
                : undefined;
        message.borderRadius =
            object.borderRadius !== undefined && object.borderRadius !== null
                ? Number(object.borderRadius)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.background !== undefined &&
            (obj.background = message.background
                ? PollData_Design_PollDesign_Background.toJSON(message.background)
                : undefined);
        message.borderRadius !== undefined && (obj.borderRadius = message.borderRadius);
        return obj;
    },
};
const basePollData_Design_PollDesign_Background = {
    type: PollData_Design_PollDesign_Background_Type.COLOR,
};
export const PollData_Design_PollDesign_Background = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Design_PollDesign_Background);
        message.type =
            object.type !== undefined && object.type !== null
                ? pollData_Design_PollDesign_Background_TypeFromJSON(object.type)
                : PollData_Design_PollDesign_Background_Type.COLOR;
        message.color =
            object.color !== undefined && object.color !== null ? String(object.color) : undefined;
        message.image =
            object.image !== undefined && object.image !== null
                ? Media.fromJSON(object.image)
                : undefined;
        message.gradient =
            object.gradient !== undefined && object.gradient !== null
                ? PollData_Design_PollDesign_Background_Gradient.fromJSON(object.gradient)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined &&
            (obj.type = pollData_Design_PollDesign_Background_TypeToJSON(message.type));
        message.color !== undefined && (obj.color = message.color);
        message.image !== undefined &&
            (obj.image = message.image ? Media.toJSON(message.image) : undefined);
        message.gradient !== undefined &&
            (obj.gradient = message.gradient
                ? PollData_Design_PollDesign_Background_Gradient.toJSON(message.gradient)
                : undefined);
        return obj;
    },
};
const basePollData_Design_PollDesign_Background_Gradient = {};
export const PollData_Design_PollDesign_Background_Gradient = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Design_PollDesign_Background_Gradient);
        message.angle =
            object.angle !== undefined && object.angle !== null ? Number(object.angle) : undefined;
        message.startColor =
            object.startColor !== undefined && object.startColor !== null
                ? String(object.startColor)
                : undefined;
        message.lastColor =
            object.lastColor !== undefined && object.lastColor !== null
                ? String(object.lastColor)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.angle !== undefined && (obj.angle = message.angle);
        message.startColor !== undefined && (obj.startColor = message.startColor);
        message.lastColor !== undefined && (obj.lastColor = message.lastColor);
        return obj;
    },
};
const basePollData_Design_OptionDesign = {};
export const PollData_Design_OptionDesign = {
    fromJSON(object) {
        const message = Object.assign({}, basePollData_Design_OptionDesign);
        message.borderRadius =
            object.borderRadius !== undefined && object.borderRadius !== null
                ? Number(object.borderRadius)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.borderRadius !== undefined && (obj.borderRadius = message.borderRadius);
        return obj;
    },
};
//# sourceMappingURL=plugin_poll.js.map